var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListBack = function SvgListBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0078D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.067 6.216.991.944-.552.526L4.57 5.843 6.506 4l.552.527-.991.944h2.804c.83 0 1.625.314 2.212.872a2.9 2.9 0 0 1 .916 2.107c0 .79-.33 1.547-.916 2.106a3.2 3.2 0 0 1-2.212.873H5.352v-.745h3.52c.621 0 1.218-.236 1.658-.654.44-.42.687-.988.687-1.58s-.247-1.161-.687-1.58a2.4 2.4 0 0 0-1.659-.654z"
  })));
};
export default SvgListBack;